import {
  Badge,
  Box,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Typography,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import BankLogo from "../assets/Logo.png";
import { brand } from "../theme";
import { isActive, navItems } from "./navItems";

// Navigation column. `collapsed` shows icons only.
export default function SideBar({ collapsed, onNavigate, onLogout }) {
  const user = JSON.parse(secureLocalStorage.getItem("profile") || "null");
  const pending = useSelector((state) => state.unApprovedInsurance) || [];
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const item = ({ text, to, icon, badge, onClick, active }) => {
    const count = badge === "approvals" ? pending.length : 0;
    const button = (
      <ListItemButton
        key={text}
        onClick={onClick || (() => { navigate(to); onNavigate?.(); })}
        selected={active}
        sx={{
          borderRadius: 2,
          mx: 1.5,
          mb: 0.5,
          minHeight: 42,
          px: collapsed ? 1.5 : 1.5,
          justifyContent: collapsed ? "center" : "flex-start",
          color: alpha("#fff", 0.72),
          "&:hover": { bgcolor: alpha("#fff", 0.06), color: "#fff" },
          "&.Mui-selected, &.Mui-selected:hover": {
            bgcolor: alpha(brand.green, 0.16),
            color: "#fff",
            boxShadow: `inset 3px 0 0 ${brand.green}`,
          },
        }}
      >
        <ListItemIcon
          sx={{ minWidth: collapsed ? 0 : 36, color: "inherit", "& svg": { fontSize: 21 } }}
        >
          <Badge color="error" badgeContent={count} invisible={!count} max={99}>
            {icon}
          </Badge>
        </ListItemIcon>
        {!collapsed && (
          <ListItemText
            primary={text}
            primaryTypographyProps={{ fontSize: 14, fontWeight: active ? 650 : 500 }}
          />
        )}
      </ListItemButton>
    );
    return collapsed ? (
      <Tooltip key={text} title={text} placement="right">
        {button}
      </Tooltip>
    ) : (
      button
    );
  };

  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        bgcolor: brand.slateDark,
        backgroundImage: `linear-gradient(180deg, ${brand.slateDark} 0%, #172129 100%)`,
        color: "#fff",
      }}
    >
      <Box
        sx={{
          height: 64,
          display: "flex",
          alignItems: "center",
          gap: 1.25,
          px: collapsed ? 0 : 2.5,
          justifyContent: collapsed ? "center" : "flex-start",
          borderBottom: `1px solid ${alpha("#fff", 0.08)}`,
          flexShrink: 0,
        }}
      >
        <Box
          component="img"
          src={BankLogo}
          alt="Sekyere Community Bank"
          sx={{ width: 34, height: "auto", bgcolor: "#fff", borderRadius: 1.5, p: 0.4 }}
        />
        {!collapsed && (
          <Box sx={{ minWidth: 0 }}>
            <Typography sx={{ fontWeight: 700, fontSize: 15, lineHeight: 1.1 }}>
              Risk Manager
            </Typography>
            <Typography sx={{ fontSize: 11, color: alpha("#fff", 0.55) }}>
              Sekyere Community Bank
            </Typography>
          </Box>
        )}
      </Box>

      {!collapsed && (
        <Typography
          sx={{
            px: 3,
            pt: 2.5,
            pb: 1,
            fontSize: 10.5,
            fontWeight: 700,
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            color: alpha("#fff", 0.4),
          }}
        >
          Menu
        </Typography>
      )}
      <List sx={{ pt: collapsed ? 2 : 0, flex: 1, overflowY: "auto" }}>
        {navItems(user).map((nav) => item({ ...nav, active: isActive(pathname, nav.to) }))}
      </List>

      <Box sx={{ borderTop: `1px solid ${alpha("#fff", 0.08)}`, py: 1.5 }}>
        {item({ text: "Log out", icon: <LogoutOutlinedIcon />, onClick: onLogout })}
      </Box>
    </Box>
  );
}
